import { render, staticRenderFns } from "./LoginScreenCapacitacionesProlipa.vue?vue&type=template&id=9f71bf4e&scoped=true"
import script from "./LoginScreenCapacitacionesProlipa.vue?vue&type=script&lang=js"
export * from "./LoginScreenCapacitacionesProlipa.vue?vue&type=script&lang=js"
import style0 from "./LoginScreenCapacitacionesProlipa.vue?vue&type=style&index=0&id=9f71bf4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f71bf4e",
  null
  
)

export default component.exports